import { render, staticRenderFns } from "./ActivityChart.vue?vue&type=template&id=13cf9d94"
import script from "./ActivityChart.vue?vue&type=script&lang=js"
export * from "./ActivityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports